export default function toRadian (angle) {
  return angle * (Math.PI / 180)
}
